var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.percent{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "percent",
    d: "M7.3,6.56c0,0.74-0.12,1.3-0.37,1.68c-0.25,0.38-0.62,0.57-1.1,0.57c-0.46,0-0.81-0.19-1.06-0.58 C4.52,7.84,4.39,7.29,4.39,6.56c0-0.74,0.12-1.3,0.36-1.67C5,4.52,5.36,4.33,5.83,4.33s0.83,0.19,1.09,0.58S7.3,5.85,7.3,6.56z  M5.06,6.56c0,0.55,0.06,0.97,0.18,1.25c0.12,0.28,0.32,0.42,0.59,0.42c0.53,0,0.8-0.55,0.8-1.66c0-1.1-0.27-1.65-0.8-1.65 c-0.27,0-0.47,0.14-0.59,0.41S5.06,6.01,5.06,6.56z M10.34,4.43l-3.96,7.14H5.67l3.96-7.14H10.34z M11.6,9.42 c0,0.74-0.12,1.3-0.37,1.68s-0.61,0.57-1.1,0.57c-0.46,0-0.82-0.19-1.07-0.58s-0.37-0.94-0.37-1.67c0-0.74,0.12-1.3,0.36-1.67 c0.24-0.37,0.6-0.56,1.08-0.56c0.46,0,0.82,0.19,1.08,0.57C11.47,8.15,11.6,8.7,11.6,9.42z M9.36,9.42c0,0.56,0.06,0.97,0.18,1.25 c0.12,0.27,0.32,0.41,0.59,0.41s0.48-0.14,0.61-0.41c0.13-0.27,0.2-0.69,0.2-1.25s-0.07-0.97-0.2-1.24c-0.13-0.27-0.33-0.4-0.61-0.4 s-0.47,0.13-0.59,0.4C9.42,8.45,9.36,8.87,9.36,9.42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPercent);
export default __webpack_public_path__ + "static/media/icon_percent.1dc374fc4b585726edaf9e71c4eae715.svg";
export { ForwardRef as ReactComponent };